export default __webpack_public_path__ + "static/media/Trust-Build.616d0bbd.jpg";